import ValidationReducer from './ValidationReducer';
export default ValidationReducer;
